import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HeaderComponent } from 'projects/tn-library/src/lib/header/header.component';
import { FooterComponent } from 'projects/tn-library/src/lib/footer/footer.component';
import { NavbarComponent } from './Navbar/Navbar.component';
import { SearchComponent } from './search/search.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTableExporterModule } from 'mat-table-exporter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { NgxMaskModule } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { AppService } from './shared/services/app.service';
import { ExternalCommonService } from './shared/services/external.common.service';

import { ExemptionSearchService } from './shared/services/exemption.search.service';
import { DatePipe } from '@angular/common';
import { ConfirmModalComponent } from './shared/component/confirm-modal/confirm-modal.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { ApplicationComponent } from './application/application.component';
import { ExternalTabsComponent } from './application/tabs/tabs.component';
import { AddresstabsComponent } from 'projects/admin/src/app/internaltabs/addresstabs/addresstabs.component';
import { ConfirmationtabComponent } from 'projects/admin/src/app/internaltabs/confirmationtab/confirmationtab.component';
import { LicensetabComponent } from 'projects/admin/src/app/internaltabs/licensetab/licensetab.component';
import { QualificationtabComponent } from 'projects/admin/src/app/internaltabs/qualificationtab/qualificationtab.component';
import { SignaturetabComponent } from 'projects/admin/src/app/internaltabs/signaturetab/signaturetab.component';
import { PaymenttabComponent } from 'projects/admin/src/app/internaltabs/paymenttab/paymenttab.component';
import { YesNoModalComponent } from 'projects/admin/src/app/shared/yes-no-modal/yes-no-modal.component';
import { WarningModalComponent } from 'projects/admin/src/app/shared/warning-modal/warning-modal.component';
import { ExternalPaymentComponent } from './application/external-payment/external-payment.component';
import { RenewalComponent } from './application/renewal/renewal.component';
import { InitialComponent } from './application/initial/initial.component';
import { DynamicModalComponent } from 'projects/admin/src/app/shared/dynamic-modal/dynamic-modal.component';
import { UploadTabComponent } from './application/upload-tab/upload-tab.component';
import { ExernalPaymentTabComponent } from './application/exernal-payment-tab/exernal-payment-tab.component';
// import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { RequestCopyComponent } from './application/request-copy/request-copy.component';
import { CreateComponent } from './application/create/create.component';
import { ExternalFilingRequestService } from './shared/services/exemptionFilingRequest';
import { ExternalDocumentService } from './shared/services/externalDocument.service';
import { MailinPaymentConfirmationComponent } from './application/mailin-payment-confirmation/mailin-payment-confirmation.component';
import { ExternalVerificationTabComponent } from './application/external-verification-tab/external-verification-tab.component';
import { RequestCopyTabComponent } from './application/request-copy-tab/request-copy-tab.component';
import { RegistrationDetailsComponent } from './registration-details/registration-details.component';
import { SanitizeHtmlPipe } from 'projects/admin/src/app/services/dom-sanitizer-pipe';
import { UserIdleModule } from 'angular-user-idle';
import { PaymentfailedComponent } from './application/paymentfailed/paymentfailed.component';
import { ExemptionPayNowComponent } from './application/exemption-pay-now/exemption-pay-now.component';
import { WarningApplicationComponent } from './shared/component/warning-application/warning-application.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { environment } from '../environments/environment';
import { ExternalConfirmationTabComponent } from './application/external-confirmation-tab/external-confirmation-tab.component';
import { ExternalNotesComponent } from './application/external-notes/external-notes.component';
import { ExternalAuthService } from './shared/services/external.auth.service';
import { AuthInterceptor } from './shared/services/auth.intercepter';
import { RegistryDownloadComponent } from './application/registry-download/registry-download.component';
import { RegistryDownloadPaymentComponent } from './application/registry-download-payment/registry-download-payment.component';
import { DownloadpaymentconfirmationComponent } from './application/registry-download/downloadpaymentconfirmation/downloadpaymentconfirmation.component';
import { DownloadpaymentfailedComponent } from './application/registry-download/downloadpaymentfailed/downloadpaymentfailed.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    NavbarComponent,
    SearchComponent,
    ConfirmModalComponent,
    ApplicationComponent,
    ExternalTabsComponent,
    AddresstabsComponent,
    ConfirmationtabComponent,
    LicensetabComponent,
    QualificationtabComponent,
    SignaturetabComponent,
    PaymenttabComponent,
    YesNoModalComponent,
    WarningModalComponent,
    ConfirmModalComponent,
    DynamicModalComponent,
    ExternalPaymentComponent,
    RenewalComponent,
    InitialComponent,
    UploadTabComponent,
    ExernalPaymentTabComponent,
    RequestCopyComponent,
    CreateComponent,
    MailinPaymentConfirmationComponent,
    ExternalVerificationTabComponent,
    RequestCopyTabComponent,
    SanitizeHtmlPipe,
    RegistrationDetailsComponent,
    PaymentfailedComponent,
    ExemptionPayNowComponent,
    WarningApplicationComponent,
    ExternalConfirmationTabComponent,
    ExternalNotesComponent,
    RegistryDownloadComponent,
    RegistryDownloadPaymentComponent,
    DownloadpaymentconfirmationComponent,
    DownloadpaymentfailedComponent
  ],
  imports: [
    NgxMaskModule.forRoot(),
    ToastrModule.forRoot(),
    UserIdleModule.forRoot({idle: 600, timeout: 300, ping: 5}),
    MatChipsModule,
    MatIconModule,
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDividerModule,
    MatMenuModule,
    MatExpansionModule,
    MatDatepickerModule,
    FlexLayoutModule,
    MatNativeDateModule,
    MatSelectModule,
    MatButtonModule,
    MatBadgeModule,
    MatTableModule,
    MatCheckboxModule,
    MatStepperModule,
    MatPaginatorModule,
    MatCardModule,
    MatRadioModule,
    MatDialogModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    DragDropModule,
    MatSortModule,
    MatTabsModule,
    MatTableExporterModule,
    MatGridListModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatTooltipModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    AppService,
    DatePipe,
    ExternalCommonService,
    ExemptionSearchService,
    ExternalFilingRequestService,
    ExternalDocumentService,
    ExternalAuthService,
    { provide: 'environment', useValue: environment }, 
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey,
      } as RecaptchaSettings,
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
